export const listViewFields = [
    { field: "prod_num", canInteract: true },
    { field: "mod_cd", canInteract: true },
    { field: "fini_cd", canInteract: true },
    { field: "prod_groupe", canInteract: true },
    { field: "prod_collection", canInteract: true },
    { field: "web_descr", canInteract: true },
    { field: "web_descr_ang", canInteract: true },
    { field: "mod_descr", canInteract: true },
    { field: "mod_descr_ang", canInteract: true },
    { field: "largeur", canInteract: true },
    { field: "hauteur", canInteract: true },
    { field: "profondeur", canInteract: true },
]